import Vue from 'vue';
import api from '../../api/emailCampaignDomains';
import * as types from '../mutation-types';

const T = types.default;

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isVerifying: false,
    isDeleting: false,
  },
};

export const getters = {
  getDomains: $state => Object.values($state.records),
  getDomain: $state => id => $state.records[id],
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  async fetch({ commit }) {
    commit(T.SET_EMAIL_CAMPAIGN_DOMAIN_UI_FLAG, { isFetching: true });
    try {
      const { data } = await api.get();
      commit(T.SET_EMAIL_CAMPAIGN_DOMAINS, data);
    } finally {
      commit(T.SET_EMAIL_CAMPAIGN_DOMAIN_UI_FLAG, { isFetching: false });
    }
  },
  async create({ commit }, payload) {
    commit(T.SET_EMAIL_CAMPAIGN_DOMAIN_UI_FLAG, { isCreating: true });
    try {
      const { data } = await api.create({ email_campaign_domain: payload });
      commit(T.ADD_EMAIL_CAMPAIGN_DOMAIN, data);
      return data;
    } finally {
      commit(T.SET_EMAIL_CAMPAIGN_DOMAIN_UI_FLAG, { isCreating: false });
    }
  },
  async verify({ commit }, id) {
    commit(T.SET_EMAIL_CAMPAIGN_DOMAIN_UI_FLAG, { isVerifying: true });
    try {
      const { data } = await api.verify(id);
      commit(T.UPDATE_EMAIL_CAMPAIGN_DOMAIN, data);
      return data;
    } finally {
      commit(T.SET_EMAIL_CAMPAIGN_DOMAIN_UI_FLAG, { isVerifying: false });
    }
  },
  async delete({ commit }, id) {
    commit(T.SET_EMAIL_CAMPAIGN_DOMAIN_UI_FLAG, { isDeleting: true });
    try {
      await api.delete(id);
      commit(T.REMOVE_EMAIL_CAMPAIGN_DOMAIN, id);
    } finally {
      commit(T.SET_EMAIL_CAMPAIGN_DOMAIN_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [T.SET_EMAIL_CAMPAIGN_DOMAINS]($state, list) {
    $state.records = (list || []).reduce(
      (acc, d) => ({ ...acc, [d.id]: d }),
      {}
    );
  },
  [T.ADD_EMAIL_CAMPAIGN_DOMAIN]($state, d) {
    Vue.set($state.records, d.id, d);
  },
  [T.UPDATE_EMAIL_CAMPAIGN_DOMAIN]($state, d) {
    Vue.set($state.records, d.id, d);
  },
  [T.REMOVE_EMAIL_CAMPAIGN_DOMAIN]($state, id) {
    Vue.delete($state.records, id);
  },
  [T.SET_EMAIL_CAMPAIGN_DOMAIN_UI_FLAG]($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
